import { BlankEditorDoTest } from '@doltech/ui/lib/figma/BlankEditor/DoTest/BlankEditorDoTest';
import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestFlowChartQuestionInstance } from '../student-do-test/model/Question/do-test-flowchart-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import { Heading } from './CompletionNoHintAnswer';

interface FlowChartAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestFlowChartQuestionInstance;
  onEditorChange?: ({ id, value }) => void;
}

export const Main = styled(Box)`
  display: grid;
  gap: 16px;
  .sentence-container {
    display: grid;
    gap: 16px;
  }
  .single-sentence {
    display: grid;
    gap: 8px;
  }
`;

export const BlankEditorContainer = styled.div`
  align-items: center;
  background: ${figmaColors.gray100};
  border: 1px solid ${figmaColors.grayMedium};
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  padding: 10px 12px;
  > div {
    background: ${figmaColors.gray100};
  }
`;

export const BlankEditorDoTestWrapper = styled(BlankEditorDoTest)`
  p {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`;

export const FlowChartAnswer = observer((props: FlowChartAnswerProps) => {
  const { data, onEditorChange, ...rest } = props;
  const { heading, sentences, setSentence, getUserAnswers } = data;
  const store = useTestSubmissionStore();

  return (
    <Main className="dol-question flowchart-answer" {...rest}>
      <Heading>{heading}</Heading>
      <div className="sentence-container">
        {sentences.map((sentence, index) => {
          const defaultTitle = `STEP ${index + 1}`;

          return (
            <div key={index} className="single-sentence">
              <Typography.Paragraph variant="semi-bold/12" color="gray100">
                {sentence.title || defaultTitle}
              </Typography.Paragraph>
              <BlankEditorContainer>
                <BlankEditorDoTestWrapper
                  withToolBar
                  key={sentence.id}
                  className="blank-container"
                  editorValue={sentence.editorValueJS}
                  no={data.no}
                  blanks={sentence.blanks as any[]}
                  blankValues={getUserAnswers()}
                  onBlankChange={(input) => {
                    if (store.preventUserAction()) return;
                    data.onAnswerQuestion(input);
                  }}
                  onEditorChange={(updatedValue) =>
                    setSentence({ id: sentence.id, value: updatedValue })
                  }
                />
              </BlankEditorContainer>
            </div>
          );
        })}
      </div>
    </Main>
  );
});
